Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityLastUpdatedView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_last_update']
  className: 'report-last-updated-section'
  tagName: 'span'

  initialize: ({report}) ->
    @title = I18n.t('customer.reports.operator_availability.last_updated')
    @report = report

  render: =>
    @$el.html(@template())
    @_updateLastUpdatedText()
    @

  _updateLastUpdatedText: =>
    lastUpdated = @report.lastUpdated()?.format('HH:mm - DD/MM/YYYY')
    @$el.find('.last-updated-text').html("#{@title}: #{lastUpdated}") if lastUpdated

  displayContent: =>
    @_updateLastUpdatedText()
    @$el.find('.last-updated-text').hide()
    @$el.find('.last-updated-placeholder').hide()
    @$el.find('.last-updated-text').show()

  hideContent: =>
    @$el.find('.last-updated-text').hide()
    @$el.find('.last-updated-placeholder').show()
